// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"421":"5eff58ac","673":"10a7ba48","720":"2ea53901"}[chunkId] + ".chunk.css";
};